import style from "./status.module.scss";
import { Status } from "./status";
import { Modal } from "../../secondary";

export const StatusModal = ({ patientData, setAdtModal }) => {
  return (
    <Modal
      modalOpen={true}
      modalClose={() => setAdtModal(false)}
      heading={"Status Information"}
      className={style.assessment_modal}
      modalSize={style.custom_modal_size}
    >
      <Status patientData={patientData} />
    </Modal>
  );
};
